import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'

import { useSourcesPageData } from 'helpers/hooks/Sources'

import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

import NewSourceDialog from 'components_new/organisms/internal/sources/NewSourceDialog'
import SourcesTable from 'components_new/organisms/internal/sources/SourcesTable'
import { getSourceRows } from 'components_new/organisms/internal/sources/SourcesTable/utils'

import PageLayout from 'components_new/templates/PageLayout'

const Sources = () => {
  const { accountLoading, allowed, fetched, sources } = useSourcesPageData()

  const [dialogOpen, setDialogOpen] = useState(false)

  if (accountLoading) {
    return null
  }

  if (!allowed) {
    return <Redirect to="/" />
  }

  return (
    <>
      <PageLayout
        topbar={{
          actions: (
            <Button
              onClick={() => setDialogOpen(true)}
              startIcon={<Icon name="Add" />}
              variant="text"
            >
              Lägg till
            </Button>
          ),
          breadcrumbs: [{ title: 'Admin' }, { title: 'Ansluten data' }]
        }}
        variant="static"
      >
        <SourcesTable
          loading={!fetched}
          onClickAdd={() => setDialogOpen(true)}
          rows={getSourceRows(sources)}
          sx={{ flex: 1 }}
        />
      </PageLayout>

      <NewSourceDialog onClose={() => setDialogOpen(false)} open={dialogOpen} />
    </>
  )
}

export default Sources
